export const LIST_SPECIALIST_REQUEST = 'LIST_SPECIALIST_REQUEST'
export const LIST_SPECIALIST_SUCCESS = 'LIST_SPECIALIST_SUCCESS'
export const LIST_SPECIALIST_FAIL = 'LIST_SPECIALIST_FAIL'

export const LIST_SPECIALIST_SUMMARY_REQUEST = 'LIST_SPECIALIST_SUMMARY_REQUEST'
export const LIST_SPECIALIST_SUMMARY_SUCCESS = 'LIST_SPECIALIST_SUMMARY_SUCCESS'
export const LIST_SPECIALIST_SUMMARY_FAIL = 'LIST_SPECIALIST_SUMMARY_FAIL'

export const CREATE_SPECIALIST_REQUEST = 'CREATE_SPECIALIST_REQUEST'
export const CREATE_SPECIALIST_SUCCESS = 'CREATE_SPECIALIST_SUCCESS'
export const CREATE_SPECIALIST_FAIL = 'CREATE_SPECIALIST_FAIL'

export const DETAIL_SPECIALIST_REQUEST = 'DETAIL_SPECIALIST_REQUEST'
export const DETAIL_SPECIALIST_SUCCESS = 'DETAIL_SPECIALIST_SUCCESS'
export const DETAIL_SPECIALIST_FAIL = 'DETAIL_SPECIALIST_FAIL'

export const UPDATE_SPECIALIST_REQUEST = 'UPDATE_SPECIALIST_REQUEST'
export const UPDATE_SPECIALIST_SUCCESS = 'UPDATE_SPECIALIST_SUCCESS'
export const UPDATE_SPECIALIST_FAIL = 'UPDATE_SPECIALIST_FAIL'

export const DELETE_SPECIALIST_REQUEST = 'DELETE_SPECIALIST_REQUEST'
export const DELETE_SPECIALIST_SUCCESS = 'DELETE_SPECIALIST_SUCCESS'
export const DELETE_SPECIALIST_FAIL = 'DELETE_SPECIALIST_FAIL'

export const RESET_SPECIALIST = 'RESET_SPECIALIST'